import type { HTMLChakraProps } from '@chakra-ui/react-v2';
import { forwardRef } from '@chakra-ui/react-v2';
import { chakra } from '@chakra-ui/react-v2';

import { usePromptBarStyles } from '../usePromptBarStyles';

export type PromptBarFloatRightProps = HTMLChakraProps<'div'>;

/**
 * Right floating container for the submit button in PromptBar.
 */
export const PromptBarFloatRight: React.FC<PromptBarFloatRightProps> =
  forwardRef<PromptBarFloatRightProps, 'div'>(({ children, ...props }, ref) => {
    const { floatRight } = usePromptBarStyles();

    return (
      <chakra.div sx={floatRight} {...props} ref={ref}>
        {children}
      </chakra.div>
    );
  });
PromptBarFloatRight.displayName = 'PromptBarFloatRight';
